var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.714 22.5998L16 17.8857L11.286 22.5998C10.7674 23.1183 9.91888 23.1183 9.40034 22.5998C8.88179 22.0812 8.88179 21.2327 9.40034 20.7142L14.1144 16.0001L9.40034 11.2861C8.88179 10.7675 8.88179 9.91899 9.40034 9.40044C9.91888 8.8819 10.7674 8.8819 11.286 9.40044L16 14.1145L20.714 9.40044C21.2326 8.8819 22.0811 8.8819 22.5997 9.40044C23.1182 9.91899 23.1182 10.7675 22.5997 11.2861L17.8856 16.0001L22.5997 20.7142C23.1182 21.2327 23.1182 22.0812 22.5997 22.5998C22.0811 23.1183 21.2326 23.1183 20.714 22.5998Z",
    fill: "#393E49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon-exit.06f00c3b179fbe40b154dc24b6503289.svg";
export { ForwardRef as ReactComponent };